import { ScrollReveal } from "@/components/base/ScrollReveal";

const works = [
  {
    title: "内装リフォーム工事 ワークスペース改装",
    location: "世田谷区",
    category: "内装リフォーム",
    duration: "2週間",
    image: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&q=80&w=800",
  },
  {
    title: "外壁塗装工事 コンクリート調仕上げ",
    location: "世田谷区・川崎市",
    category: "外壁塗装",
    duration: "1週間",
    image: "https://image.space.rakuten.co.jp/d/strg/ctrl/9/814bcd236738531f3e5a00b5240ce3d81c34ba64.78.2.9.2.jpeg",
  },
  {
    title: "浴室ハウスクリーニング",
    location: "川崎市麻生区",
    category: "ハウスクリーニング",
    duration: "1日",
    image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80&w=800",
  },
  {
    title: "エアコン内部洗浄サービス",
    location: "世田谷区・目黒区",
    category: "エアコン洗浄",
    duration: "半日",
    image: "https://www.osoujihonpo.com/assets/images/guide/body/photo-240607-06.jpg",
  },
];

export default function Works() {
  return (
    <section
      id="works"
      role="region"
      aria-label="施工事例"
      className="relative bg-background-50 py-20 md:py-32 px-6 md:px-16 lg:px-24"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12 md:mb-16">
          <div>
            <div className="inline-flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-primary-500"></span>
              <span className="text-xs tracking-[0.3em] uppercase text-primary-700 font-medium">
                Works
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              施工事例
            </h2>
          </div>
          <a
            href="https://wind-sekoujirei1.my.canva.site/page-4/page-13"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm font-semibold text-foreground-800 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            すべての事例を見る
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <ScrollReveal direction="up" stagger threshold={0.03} rootMargin="0px 0px -10px 0px">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8" role="list" aria-label="施工事例一覧">
            {works.map((w, i) => (
              <article key={i} role="listitem" itemScope itemType="https://schema.org/CreativeWork" className="group cursor-pointer">
                <a
                  href="https://wind-sekoujirei1.my.canva.site/page-4/page-13"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                  aria-label={`${w.title}の詳細を見る`}
                >
                <div className="relative overflow-hidden rounded-2xl mb-5">
                  <div className="aspect-[4/3]">
                    <img
                      src={w.image}
                      alt={w.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1.5 rounded-full bg-background-50/95 backdrop-blur-md text-xs font-bold text-foreground-900">
                      {w.category}
                    </span>
                  </div>
                  <div className="absolute bottom-4 right-4 w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-arrow-right-up-line text-background-50 text-xl"></i>
                  </div>
                </div>
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-600 mb-2">
                  <span className="flex items-center gap-1.5" itemProp="contentLocation">
                    <i className="ri-map-pin-line"></i> {w.location}
                  </span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line"></i> 工期 {w.duration}
                  </span>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 group-hover:text-primary-700 transition-colors" itemProp="name">
                  {w.title}
                </h3>
                </a>
              </article>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}